
import React, { useEffect, useState } from 'react';
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-react';
import './Toast.css';

const Toast = ({ 
    message, 
    type = 'success', 
    duration = 3000, 
    onClose,
    isHtml = false 
}) => {
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            handleClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration]);

    const handleClose = () => {
        setIsExiting(true);
        setTimeout(() => {
            if (onClose) onClose();
        }, 300); // Match animation duration
    };

    const getIcon = () => {
        switch (type) {
            case 'success': return <CheckCircle size={18} />;
            case 'danger':
            case 'error': return <XCircle size={18} />;
            case 'warning': return <AlertTriangle size={18} />;
            case 'info': return <Info size={18} />;
            default: return <Info size={18} />;
        }
    };

    return (
        <div className={`rova-toast rova-toast-${type} ${isExiting ? 'exit' : ''}`}>
            <div className="toast-icon">
                {getIcon()}
            </div>
            <div className="toast-content">
                {isHtml ? (
                    <div dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                    <p>{message}</p>
                )}
            </div>
            <button className="toast-close" onClick={handleClose}>
                <X size={14} />
            </button>
        </div>
    );
};

export default Toast;
